import { render, staticRenderFns } from "./InfoCustomer.vue?vue&type=template&id=33502364&"
import script from "./InfoCustomer.vue?vue&type=script&lang=js&"
export * from "./InfoCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports